import { render, staticRenderFns } from "./OperateTips.vue?vue&type=template&id=4954cf8a&scoped=true&"
import script from "./OperateTips.vue?vue&type=script&lang=js&"
export * from "./OperateTips.vue?vue&type=script&lang=js&"
import style0 from "./OperateTips.vue?vue&type=style&index=0&id=4954cf8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954cf8a",
  null
  
)

export default component.exports